import { createPaginatedSlice, LOADING_KEY } from "../../../helpers/reduxHelper";

const paginatedTextures = createPaginatedSlice('paginatedTextures', {
  defaultState: {
    tempSelectedTexture: null,
    tempSelectedMaterial: null,
    allLoadedMaterials: null
  },
  reducers: {
    setTempSelectedTexture: (state, { payload }) => {
      state.tempSelectedTexture = payload;
    },
    setTempSelectedMaterial: (state, { payload }) => {
      state.tempSelectedMaterial = payload;
    },
    setAllLoadedMaterials: (state, { payload }) => {
      state.allLoadedMaterials = payload;
    }
  }
});

export const paginatedTexturesActions = paginatedTextures.actions
export const paginatedTexturesSelector = state => state.paginatedTextures;
export const paginatedTexturesReducer = paginatedTextures.reducer;
export default paginatedTexturesReducer

export const paginatedTexturesSelectors = paginatedTextures.LF.selectors

export const selectPendingUploadIds = (state) => {
  const texturesLoading = paginatedTexturesSelectors.selectItemsLoading(state);

  const loadingIds = Object.entries(texturesLoading)
    .filter(([id, itemInfo]) => itemInfo[LOADING_KEY.CARD_LOADING] === true)
    .map(([id]) => id);

  // TODO: check later if we use texture in curator or not
  return loadingIds;
}

export const selectTempSelectedTexture = (state) => state.paginatedTextures.tempSelectedTexture;
export const selectTempSelectedMaterial = (state) => state.paginatedTextures.tempSelectedMaterial;
export const selectAllLoadedMaterials = (state) => state.paginatedTextures.allLoadedMaterials;